import React from 'react'

import { faMapMarkerAlt, faVideo } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

import './MonthEventContainer.scss'

const MonthEventContainer = ({ children, isVirtual = false, allowRepLocationType = false }) => {
  const indicatorIcon = () => {
    if (allowRepLocationType) {
      return <span className="dot indicator" />
    } else if (isVirtual) {
      return (
        <FontAwesomeIcon
          className="indicator"
          icon={faVideo}
        />
      )
    } else {
      return (
        <FontAwesomeIcon
          className="indicator"
          icon={faMapMarkerAlt}
        />
      )
    }
  }
  return (
    <div className="month-event-container-comp">
      {indicatorIcon()}
      <div className="month-event-summary">{children}</div>
    </div>
  )
}

MonthEventContainer.propTypes = {
  children: PropTypes.node.isRequired,
  isVirtual: PropTypes.bool,
}

export default MonthEventContainer
